import { render, staticRenderFns } from "./SalesList.vue?vue&type=template&id=a64eb11a&scoped=true&lang=pug"
import script from "./SalesList.vue?vue&type=script&lang=js"
export * from "./SalesList.vue?vue&type=script&lang=js"
import style0 from "./SalesList.vue?vue&type=style&index=0&id=a64eb11a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64eb11a",
  null
  
)

export default component.exports